/**
 * @generated SignedSource<<647e3122206e98d18c89281025ad94c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ImageVersionTypeName = "thumb" | "small" | "medium" | "large" | "zoom" | "original" | "master" | "placeholder" | "datamatics" | "transparent" | "bgProcessed" | "oldMaster" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpHead_item$data = {
  readonly microdata: string | null;
  readonly microdataWithImageObj: string | null;
  readonly pdpURL: string | null;
  readonly localizedPdpUrl: string | null;
  readonly pdpMeta: {
    readonly title: string | null;
    readonly description: string | null;
    readonly ogTitle: string | null;
    readonly productPriceAmount: string | null;
    readonly productPriceCurrency: string | null;
  } | null;
  readonly photos: ReadonlyArray<{
    readonly versions: ReadonlyArray<{
      readonly webPath: string | null;
      readonly type: {
        readonly name: ImageVersionTypeName | null;
      } | null;
    } | null> | null;
  } | null> | null;
  readonly isListingNotListed: boolean | null;
  readonly isPriceUponRequest: boolean | null;
  readonly seller: {
    readonly isInternal: boolean | null;
    readonly isAccessible: boolean | null;
  } | null;
  readonly isSold: boolean | null;
  readonly pdpHeadMetrics: ReadonlyArray<{
    readonly value: string | null;
  } | null> | null;
  readonly " $fragmentType": "PdpHead_item";
};
export type PdpHead_item$key = {
  readonly " $data"?: PdpHead_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpHead_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "currency",
  "variableName": "forcedCurrency"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "forcedCurrency"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpHead_item",
  "selections": [
    {
      "alias": null,
      "args": [
        (v0/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "microdata",
      "storageKey": null
    },
    {
      "alias": "microdataWithImageObj",
      "args": [
        {
          "kind": "Literal",
          "name": "addImageObj",
          "value": true
        },
        (v0/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "microdata",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdpURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localizedPdpUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "pdpMetaItems",
      "kind": "LinkedField",
      "name": "pdpMeta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ogTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productPriceAmount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productPriceCurrency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "kind": "LinkedField",
          "name": "versions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ImageVersionType",
              "kind": "LinkedField",
              "name": "type",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingNotListed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPriceUponRequest",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isInternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": "pdpHeadMetrics",
      "args": [
        {
          "kind": "Literal",
          "name": "metricTypes",
          "value": [
            "LISTING_VIEWS"
          ]
        },
        {
          "kind": "Literal",
          "name": "timeRange",
          "value": "LAST_6_MONTHS"
        },
        {
          "kind": "Literal",
          "name": "useLocalizedMetrics",
          "value": true
        }
      ],
      "concreteType": "MetricDetailType",
      "kind": "LinkedField",
      "name": "metrics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": "metrics(metricTypes:[\"LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\",useLocalizedMetrics:true)"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "cc3bbcdfdea2a6555f924ecbd25aff04";

export default node;
